import { FC } from "react"
import dayjs, { Dayjs } from "dayjs"
import DatePicker from "@/components/shared/DatePicker"
import "./index.scss"

interface DateRangePickerProps {
   from: Dayjs
   to: Dayjs
   timezone: string
   onChange: (range: { from: Dayjs; to: Dayjs }) => void
   maxRangeDays?: number
   maxDate?: Dayjs
}

const DateRangePicker: FC<DateRangePickerProps> = ({
   from,
   to,
   timezone,
   onChange,
   maxRangeDays = 7,
   maxDate = dayjs().tz(timezone),
}) => {
   const fromPlusMaxRange = from.add(maxRangeDays, "day")
   const endMaxDate = fromPlusMaxRange.isBefore(maxDate)
      ? fromPlusMaxRange
      : maxDate

   const handleFromChange = (value: Dayjs | null) => {
      if (!value) return
      let nextTo = to
      if (to.diff(value, "day") < 0) nextTo = value
      if (to.diff(value, "day") > maxRangeDays)
         nextTo = value.add(maxRangeDays, "day")
      onChange({ from: value, to: nextTo })
   }

   const handleToChange = (value: Dayjs | null) => {
      if (!value) return
      let nextFrom = from
      if (value.diff(from, "day") < 0) nextFrom = value
      if (value.diff(from, "day") > maxRangeDays)
         nextFrom = value.subtract(maxRangeDays, "day")
      onChange({ from: nextFrom, to: value })
   }

   return (
      <div className="date-range-picker">
         <div className="date-range-picker__fields">
            <DatePicker
               label="Start date"
               showLabel={false}
               size="small"
               format="YYYY-MM-DD"
               selectedDate={from}
               timezone={timezone}
               onDateChange={handleFromChange}
               maxDate={maxDate}
            />
            <DatePicker
               label="End date"
               showLabel={false}
               size="small"
               format="YYYY-MM-DD"
               selectedDate={to}
               timezone={timezone}
               onDateChange={handleToChange}
               minDate={from}
               maxDate={endMaxDate}
            />
         </div>
      </div>
   )
}

export default DateRangePicker
